<script setup lang="ts">
import { PriceOverrideStatus } from "@classes-service-types/price-override-status.ts";
import { RouterLink, useRoute } from "vue-router";
import DashboardCard from "@/components/MyStudents/Display/DashboardCard.vue";
import { useFilters } from "../composables/useFilters";
import type { Props } from "./types";

defineOptions({
  name: "AnonymousAdvisingHeader",
});

const route = useRoute();

const props = withDefaults(defineProps<Props>(), {
  anonymousCount: 0,
  nonAnonymousCount: 0,
});

const { isAnonymous } = useFilters();
</script>

<template>
  <div class="grid grid-cols-2 gap-8">
    <router-link :to="{ name: 'my-students-app-anonymous-advising', query: { ...route.query, isAnonymous: 'true' } }">
      <DashboardCard
        :number="anonymousCount ?? 0"
        description="Anonymous"
        data-test-id="anonymous-advising-anonymous-card"
        :class-format="`${isAnonymous === true ? 'bg-blue-400' : 'bg-white'} shadow-lg rounded-lg p-4 px-6`"
        mui-icon-name="person_off"
        mui-icon-class="text-university-tertiary"
        :loading="loading"
      />
    </router-link>
    <router-link :to="{ name: 'my-students-app-anonymous-advising', query: { ...route.query, isAnonymous: 'false' } }">
      <DashboardCard
        :number="nonAnonymousCount ?? 0"
        description="Not Anonymous"
        data-test-id="anonymous-advising-not-anonymous-card"
        :class-format="`${isAnonymous === false ? 'bg-blue-400' : 'bg-white'} shadow-lg rounded-lg p-4 px-6`"
        mui-icon-name="person"
        mui-icon-class="text-green-bright"
        :loading="loading"
      />
    </router-link>
  </div>
</template>

<style scoped>
</style>
